<template>
  <div>
    <div class="row">
      <div class="col-md-12 mb-5">
        <div class="flex flex-wrap">
          <vs-icon icon="info" size="small" color="red"></vs-icon>
          <label class="mt-1 ml-2">El monto <strong>'Liquida con'</strong> incluye el saldo insoluto + el saldo
            vencido.</label>
        </div>
      </div>
    </div>
    <div class="flex flex-col lg:flex-row items-start gap-4">
      <div class="inputs-form w-full lg:w-3/12 mb-4">
        <div class="flex flex-col gap-4">
          <vs-tabs v-model="activeTab" @change="capitalPaymentMethodHandler">
            <vs-tab label="Abono a capital">
              <div class="flex flex-col gap-4">
                <vs-input label="Cantidad a abonar" type="number" v-model="abono_amount" />
                <vs-checkbox @change="recalculate()" v-model="chargeWithInterest">
                  Pago con intereses
                </vs-checkbox>
                <div class="flex gap-4">
                  <vs-button color="dark" size="small" v-if="abono_amount !== '' && abono_amount > 0 && !loading"
                    @click="simulatePayment">
                    Calcular
                  </vs-button>

                  <vs-button color="success" size="small" v-if="master_abonos.length > 0 && !loading"
                    @click="fundCapitalActivePrompt = true">
                    Abonar a capital
                  </vs-button>
                </div>
                <label style="color:red" v-if="!minimum">La cantidad a abonar es menor al 20% del saldo
                  insoluto.</label>
              </div>
            </vs-tab>
            <vs-tab label="Liquidar">
              <div class="flex flex-col gap-4">
                <div class="form-field">
                  <label class="font-bold">Monto a liquidar</label>
                  <div class="input bg-grey-light p-4 rounded text-center font-bold">
                    {{ abono_amount | currency }}
                  </div>
                </div>

                <vs-checkbox @change="recalculate()" v-model="chargeWithInterest">
                  Pago con intereses
                </vs-checkbox>
                <div class="flex gap-4">
                  <vs-button :disabled="!(needed === 0 && credit_status === al_corriente) || loading" color="dark"
                    size="small" v-if="abono_amount !== '' && abono_amount > 0 && !loading" @click="simulatePayment">
                    Simular liquidación
                  </vs-button>

                  <vs-button color="success" size="small"
                    :disabled="!(needed === 0 && credit_status === al_corriente) || loading"
                    v-if="master_abonos.length > 0 && !loading" @click="fundCapitalActivePrompt = true">
                    Liquidar
                  </vs-button>
                </div>
                <label style="color:red" v-if="!minimum">La cantidad a abonar es menor al 20% del saldo
                  insoluto.</label>
              </div>
            </vs-tab>
          </vs-tabs>

        </div>
      </div>
      <div class="capital-payment-info w-full lg:w-9/12 flex bg-grey-light rounded p-4 justify-between gap-4">
        <div class="flex flex-col">
          <span class="font-bold">Saldo insoluto</span>
          <div>${{ formatPrice(settlement - total_due) }}</div>
        </div>
        <div class="flex flex-col">
          <span class="font-bold">Saldo vencido</span>
          <span style="color:red">${{ formatPrice(total_due) }}</span>
        </div>
        <div class="flex flex-col">
          <span class="font-bold">Liquida con</span>
          <span style="color:green;">${{ formatPrice(settlement, 2) }}</span>
        </div>
        <div class="flex flex-col">
          <span class="font-bold">Nuevo Liquida con</span>
          <span style="color:green;">${{ formatPrice(new_settlement, 2) }}</span>
        </div>
        <!--<div class="flex flex-col">
          <span class="font-bold">Número de pago</span>
          <span>{{ number }}</span>
        </div>-->
        <div class="flex flex-col">
          <span class="font-bold">
            {{ needed === 0 && credit_status === al_corriente ? '' : 'Abona' }}
          </span>
          <div>
            <vs-button v-if="needed === 0 && credit_status === al_corriente" color="dark" size="small"
              @click="simulateSettlement">Simular Liquidación
            </vs-button>
            <span v-else>${{ formatPrice(needed, 2) }}</span>
          </div>
        </div>
        <div class="flex flex-col" v-if="needed === 0 && credit_status === al_corriente && !loading">
          <span class="font-bold"></span>
          <span>
            <vs-button :disabled="!finishSimulationMade" color="danger" size="small"
              @click="finishProjectActivePrompt = true">
              Liquidar
            </vs-button>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-xs-12">
        <vs-table class="table" style="width:100%" :data="master_abonos" noDataText="No hay datos disponibles">
          <template slot="thead">
            <!--th class="header">Mes</th!-->
            <vs-th class="header">Fecha de pago</vs-th>
            <vs-th class="header">Pago</vs-th>
            <vs-th class="header">Pago efectivo</vs-th>
            <vs-th class="header">Saldo inicial</vs-th>
            <vs-th class="header">Amortización</vs-th>
            <vs-th class="header">Intereses</vs-th>
            <vs-th class="header">IVA</vs-th>
            <vs-th class="header">Comisión</vs-th>
            <vs-th class="header">Abono a capital</vs-th>
            <vs-th class="header">Saldo final</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr v-for="abono in master_abonos">
              <!--td>{{abono.number}}</td!-->
              <vs-td>{{ abono.payment_date }}</vs-td>
              <vs-td>${{ formatPrice(abono.payment, 2) }}</vs-td>
              <vs-td style="color:red">${{ formatPrice(abono.cash_payment, 2) }}</vs-td>
              <vs-td>${{ formatPrice(abono.initial_debt, 2) }}</vs-td>
              <vs-td>${{ formatPrice(abono.amortization, 2) }}</vs-td>
              <vs-td>${{ formatPrice(abono.interest, 2) }}</vs-td>
              <vs-td>${{ formatPrice(abono.tax, 2) }}</vs-td>
              <vs-td>${{ formatPrice(abono.client_comission, 2) }}</vs-td>
              <vs-td>${{ formatPrice(abono.capital_payment, 2) }}</vs-td>
              <vs-td>${{ formatPrice(abono.final_debt, 2) }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <!-- COMFIRMACION DE ABONO A CAPITAL CONSOLIDADO -->
    <vs-prompt class="capital-payment-prompt" title="Abono a capital" @cancel="twoFactorCode = ''" @accept="makePayment"
      color="success" accept-text="Confirmar" cancel-text="Cancelar" :is-valid="validTwoFactorCode"
      :active.sync="fundCapitalActivePrompt">
      <div class="con-exemple-prompt">
        <span>Abono a capital de <strong>${{ this.formatPrice(abono_amount, 2) }}</strong><br>Confirma con tu segundo
          factor de autenticación</span>
        <vs-input placeholder="Código" vs-placeholder="Code" v-model="twoFactorCode" class="mt-3 w-full" />
      </div>
      <vs-table :data="recordPayments" class="mt-5">
        <template slot="thead">
          <vs-th>Pago</vs-th>
          <vs-th>Amortización</vs-th>
          <vs-th>Interés</vs-th>
          <vs-th>IVA</vs-th>
          <vs-th>Comisión</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data">
            <vs-td>{{ item.due | currency }}</vs-td>
            <vs-td>{{ item.amortization | currency }}</vs-td>
            <vs-td>{{ item.interest | currency }}</vs-td>
            <vs-td>{{ (item.tax + item.client_comission_tax) | currency }}</vs-td>
            <vs-td>{{ item.client_comission | currency }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-prompt>
    <!-- COMFIRMACION DE LIQUIDACION CONSOLIDADA -->
    <vs-prompt title="Liquidación de crédito" @cancel="twoFactorCode = ''" @accept="liquidate" color="danger"
      accept-text="Confirmar" cancel-text="Cancelar" :is-valid="validTwoFactorCode"
      :active.sync="finishProjectActivePrompt">
      <div class="con-exemple-prompt">
        <span>Liquidación de crédito.<br>Confirma con tu segundo factor de autenticación:</span>
        <vs-input placeholder="Código" vs-placeholder="Code" v-model="twoFactorCode" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { formatPrice } from '../../../../components/admin/filters.js';
import CreditStatusEnum from "@/bl/enums/CreditStatusEnum";

export default {
  name: "FundCapital",
  props: ['project_id'],
  mounted() {
    this.simulateGeneralSettlement();
  },
  watch: {
    activeTab() {
      if (this.activeTab === 1) {
        this.abono_amount = this.new_settlement;
      } else {
        this.abono_amount = 0;
      }
    }
  },
  data() {
    return {
      activeTab: 0,
      al_corriente: CreditStatusEnum.AL_CORRIENTE,
      recordPayments: [],
      fundCapitalActivePrompt: false,
      finishProjectActivePrompt: false,
      loading: false,
      next_master_payment: 0,
      master_abonos: [],
      abono_amount: 0,
      settlement: 0,
      new_settlement: 0,
      number: 0,
      needed: 0,
      credit_status: 0,
      minimum: true,
      finishSimulationMade: false,
      total_due: 0,
      twoFactorCode: '',
      chargeWithInterest: true
    }
  },
  computed: {
    validTwoFactorCode() {
      return this.twoFactorCode !== "";
    },
  },
  methods: {
    formatPrice,
    capitalPaymentMethodHandler(ev) {
      // alert(ev) @deprecated
    },
    simulateGeneralSettlement() {
      axios.get('/api/cobranza/liquidar/' + this.project_id).then(response => {
        this.settlement = response.data.settlement;
        this.new_settlement = response.data.new_settlement;
        this.master_abonos = response.data.amortization;
        this.number = response.data.number;
        this.needed = response.data.needed;
        this.credit_status = response.data.credit_status;
        this.total_due = response.data.total_due;
      });
    },
    async recalculate() {
      if (this.abono_amount) {
        await this.simulatePayment();
      }
    },
    async simulatePayment() {
      this.loading = true;
      this.showLoading(true);
      try {
        let response = await axios.post('/api/backoffice/treasury/capital-payment/consolidated/simulate', {
          project_id: this.project_id,
          amount: this.abono_amount,
          with_interest: this.chargeWithInterest
        })

        //this.next_master_payment = response.data.payments
        this.master_abonos = response.data.payments
        this.recordPayments = response.data.recordPayments;
        this.minimum = response.data.minimum
        // this.master_abonos = response.data.total_amort_balance_table
        Vue.toasted.clear()
      } catch (error) {
        if (error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
          this.errorNotif("Aviso", error.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      } finally {
        this.loading = false;
        this.showLoading(false);
      }
    },
    makePayment() {
      this.loading = true
      this.showLoading(true);
      axios.post('/api/backoffice/treasury/capital-payment/consolidated/apply', {
        project_id: this.project_id,
        amount: this.abono_amount,
        code: this.twoFactorCode,
        with_interest: this.chargeWithInterest
      }).then(response => {
        this.showLoading(false);
        this.successNotif("Aviso", 'Abono a capital realizado.');
        this.resetValues();
        this.loading = false
        this.$emit('updated', 1)
      }).catch(error => {
        this.showLoading(false);
        if (error.response != undefined && error.response.data != undefined && error.response.data.message != undefined) {
          this.errorNotif("Aviso", error.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
        this.loading = false
      })
      this.twoFactorCode = '';
    },
    simulateSettlement() {
      Vue.toasted.clear()
      this.abono_amount = this.settlement;
      this.simulatePayment();
      this.finishSimulationMade = true;
    },
    liquidate() {
      this.loading = true
      this.showLoading(true);
      axios.post('/api/cobranza/liquidar', {
        withInterest: this.chargeWithInterest,
        project_id: this.project_id,
        code: this.twoFactorCode
      }).then(response => {
        this.showLoading(false);
        this.successNotif("Aviso", 'Proyecto liquidado.');
        this.resetValues();
        this.loading = false
        this.$emit('updated', 1)
      }).catch(error => {
        this.showLoading(false);
        if (error.response != undefined && error.response.data != undefined && error.response.data.message != undefined) {
          this.errorNotif("Aviso", error.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
        this.loading = false
      })
      this.twoFactorCode = '';
    },
    resetValues() {
      this.master_abonos = [];
      this.next_master_payment = '';
      this.abono_amount = '';
    }
  }
}
</script>
<style>
.capital-payment-prompt .vs-dialog {
  max-width: 650px !important;
}
</style>